import React, { useState, useRef } from 'react'
import { FormGroup, Input, Button, Spinner } from 'reactstrap';
import styles from './Comment.module.scss';
import Comment from './Comment';
import useApiPrivate from '../../../utils/hooks/useApiPrivate';
import useAuth from '../../../utils/hooks/useAuth';
import { Link, useParams } from 'react-router-dom';
import { Toast } from 'primereact/toast';

export function debounce(fn) {
    let timeout;
    return function (...args) {
      if (timeout) clearTimeout(timeout);
  
      timeout = setTimeout(() => {
        fn(...args);
      }, 3000);
    };
  }

  const COMMENT_URL = 'api/v1/comments';

export default function Comments({data, productOwnerId, onCallProductComment}) {
    const apiPrivate = useApiPrivate();
    const { auth } = useAuth();
    const { id } = useParams();
    const toast = useRef(null);

    let [commentInput, setCommentInput] = useState("");
    let [comments, setComments] = useState(data);
    const [isLoading, setIsLoading] = useState(false);

    const showSuccess = (message) => {
        toast.current.show({severity:'success', summary: 'Success', detail: message, life: 3000});
    }
    const showError = (message) => {
        toast.current.show({severity:'error', summary: 'Error', detail: message, life: 3000});
    }

    const newComment = async (comment, id) => {
        setIsLoading(true);

        try{
            const response = await apiPrivate.post(COMMENT_URL, JSON.stringify({product_id: id, comment: comment}));
                setCommentInput('');
                setIsLoading(false);
                showSuccess('Your comment has been registered successfully')
                setTimeout(() => {
                    onCallProductComment();
                },2000)
        }
        catch (error) {
            if (error?.response?.status === 400 || error?.response?.status === 401 || error?.response?.status === 422 || error?.response?.status === 429 || error?.response?.status === 500) {
                showError(error?.response?.data?.message)
            } 
            setIsLoading(false);
        }
        finally{
            setIsLoading(false);
        }
    }

  return (
    <>
        <Toast ref={toast} position="top-center" />
   
        {auth?.token 
            ? (
                <FormGroup className={`mb-4`}>
                    <Input 
                        type={'textarea'} 
                        value={commentInput}
                        className={`${styles.askQuestion} mb-2`} 
                        placeholder="Ask the seller your question"
                        onChange={(e) => debounce(setCommentInput(e.target.value))}
                        ></Input>
                    <Button 
                        className={`px-4`}
                        disabled={commentInput.length < 10 || isLoading && true}
                        onClick={() => {
                                newComment(commentInput, id);
                            }
                        }
                    >
                        {
                            isLoading 
                            ? (
                                <>
                                <Spinner size="sm">
                                    Loading...
                                </Spinner>
                                <span>
                                    {' '}Loading
                                </span>
                                </>
                            )
                            : 'Send'
                        }
                    </Button>
                </FormGroup>
            ) 
            : (
                <div className={`${comments.length > 0 ? 'mb-3' : ''}`}>
                    Log in to your account to ask the seller of this product. 
                    <Link to="/login" className={`text-decoration-none fw-bold ${styles.lgtBlueLink}`}>
                        {' '}Login / Register
                    </Link>
                </div>

            )
        }
        
        <div>
            {
                comments &&
                    comments.map((comment) => (
                        <Comment onCallProductComment={onCallProductComment} productOwnerId={productOwnerId} key={comment.id} comment={comment}/>
                 
                        ))
            }
        </div>
    </>
  )
}
